import React from 'react'
import DatePickerContainer from '../../../../Components/Forms/FormWidgets/Datepicker'

export default function DatePicker() {
    return (
        <div className='page-body'>
            <DatePickerContainer />
        </div>
    )
}